export const staticSelectEn = {
  staticSelectOptions: {
    requested: 'Requested',
    workScheduled: 'Work Scheduled',
    resolved: 'Resolved',
    declined: 'Declined',
    spam: 'Spam',
  },
} as const;
export const staticSelectFr = {
  staticSelectOptions: {
    requested: 'Demandé',
    workScheduled: 'Travaux planifiés',
    resolved: 'Résolu',
    declined: 'Refusé',
    spam: 'Pourriel',
  },
} as const;
